import { useLocation, useNavigate } from "react-router-dom"

import { getSlugSignInPath } from "@/helpers/signin.helpers"

export const useSlugSignInRedirect = () => {
  const navigate = useNavigate()
  const location = useLocation()
  return (slug: string) => {
    const query = location.search ? `${location.search}` : ""
    const pathname =
      location.pathname !== "/signin"
        ? getSlugSignInPath(slug, `${location.pathname}${query}`)
        : ""
    navigate(pathname)
  }
}
